import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';
import {
  CouponRuleHistoryEntry,
  unwrapRuleHistory
} from './coupon-rule-history.util';

@Injectable({ providedIn: 'root' })
export class CouponRuleHistoryService {
  private http = inject(HttpClient);

  list(
    couponId: number,
    query: { from?: string; to?: string }
  ): Observable<CouponRuleHistoryEntry[]> {
    let params = new HttpParams();
    if (query.from) {
      params = params.set('from', query.from);
    }
    if (query.to) {
      params = params.set('to', query.to);
    }
    return this.http
      .get<unknown>(
        `${environment.apiUrl}/coupon/rule-history/${encodeURIComponent(String(couponId))}`,
        {
          headers: this.authHeaders(),
          params
        }
      )
      .pipe(map((body) => unwrapRuleHistory(body)));
  }

  private authHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    if (StorageService.userLogged && StorageService.token) {
      return headers.set('Authorization', `Bearer ${StorageService.token}`);
    }
    return headers;
  }
}
